import React from 'react';
import AppRoutes from './routes/AppRoutes';
import './App.css'; // Make sure Tailwind is imported here or in index.js

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;